import { cn } from '@/lib/cn';

/**
 * סרגל התקדמות (PRD 5.6.3).
 *
 * RTL: הסרגל מתמלא מימין לשמאל, ולכן אין כאן translate או left, אלא
 * רוחב על אלמנט שיושב ב start של המסלול.
 *
 * הסרגל לבד הוא צבע בלי מילה, ולכן הוא תמיד מגיע עם label שנקרא גם
 * בקורא מסך.
 */
export function Progress({
  value,
  max,
  label,
  className,
}: {
  value: number;
  max: number;
  label: string;
  className?: string;
}) {
  const percent = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;
  const done = max > 0 && value >= max;

  return (
    <div className={cn('grid gap-1', className)}>
      <div
        role="progressbar"
        aria-valuenow={value}
        aria-valuemin={0}
        aria-valuemax={max}
        aria-label={label}
        className="h-2 overflow-hidden rounded-pill bg-olive-soft"
      >
        <div
          className={cn('h-full rounded-pill transition-[width]', done ? 'bg-good' : 'bg-olive')}
          style={{ width: `${percent}%` }}
        />
      </div>
      <span className="text-label text-muted">{label}</span>
    </div>
  );
}
